// extracted by mini-css-extract-plugin
export default {"container":"ReadOnlyParameterContainer_container__uR-GF","container-default":"ReadOnlyParameterContainer_container-default__vC8Ap"};